.row {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.toggleGroup {
  display: inline-flex;
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  overflow: hidden;
}

.segment {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: var(--tuna-spacing-1) var(--tuna-spacing-3);
  border: 0;
  background: transparent;
  cursor: pointer;
}

.segmentActive {
  background: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
}
